import { CancelOptionMutation } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

// オプションを解約する
export const cancelOptionMutationHandler =
  graphql.mutation<CancelOptionMutation>(
    "cancelOption",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          cancelOption: {
            result: true,
          },
        },
      });
    }
  );
